export default __webpack_public_path__ + "67c7a66ace9512aea9f82492366feaca.ttf";